import { IAddOfferResponse, IEditReferral } from "../../utils/types";
import { apiManager } from "../api-manager";

export const editReferralOffer = async (id: string, body: IEditReferral) => {
  const res = await apiManager.patch<IAddOfferResponse>(
    `/referral-offer/${id}/modify`,
    body
  );
  return res;
};
